import { useEffect } from 'react';
/**
 * Hook to notify the user in case of potential data loss when
 * performing a page transition (internal or external).
 * @param active True if the prompt should be shown, otherwise false.
 * @param history The history of the currently used router.
 * @param message The message to display when the prompt is shown.
 */
export function usePrompt(active, history, message, onTransition) {
    useEffect(function () {
        if (active) {
            var beforeUnload_1 = function (ev) {
                ev.returnValue = message;
                return message;
            };
            var unlisten_1 = onTransition && history.listen(onTransition);
            var unblock_1 = message && history.block(message);
            window.addEventListener('beforeunload', beforeUnload_1);
            return function () {
                unlisten_1 === null || unlisten_1 === void 0 ? void 0 : unlisten_1();
                unblock_1 === null || unblock_1 === void 0 ? void 0 : unblock_1();
                window.removeEventListener('beforeunload', beforeUnload_1);
            };
        }
        return function () { };
    }, [active, message]);
}
//# sourceMappingURL=usePrompt.js.map